export const buildInclusions = [
  'Company and opportunity profiling',
  'Custom ATS with dashboards, workflows, and job board integrations',
  'Culture video and ad copywriting',
  'Landing pages and candidate application flows',
  'Full funnel design, from ad to onboarding',
  'Compensation and role benchmarking by region',
  'Pre-launch system stress test',
  'Team training and 90-day coaching to optimize output',
]

export const monthlyInclusions = [
  'Active ad management and real-time optimization',
  'Live applicant screening, 14 hrs/day, 7 days/week',
  'Interview auditing and coaching to improve retention',
  'Monthly recruiting review and ongoing consulting',
  'Discounted Sales School tickets for hires that did not come through us',
]

export const salesSchoolInclusion =
  'Unlimited access to Sales School for D2D HIRE sourced candidates included!'

export const commitments = [
  {
    title: 'Coachability',
    description:
      'Our strongest partnerships are always with the most coachable teams. We bring the playbook, you run it with us.',
  },
  {
    title: 'Commitment',
    description:
      'Be all in for 90 days, the initial term of our agreement. Like full commission sales, there are speed bumps early. Scaling a team is not for dabblers.',
  },
  {
    title: 'Tracking',
    description:
      'Our coaching and our billing both run on your numbers. If we are going to build a healthy recruiting engine together, we both have to see the stats.',
  },
]

export const leaderBuildInclusions = [
  'Leadership opportunity and company profiling',
  'Custom ATS with dashboards, workflows, and job board integrations',
  'Culture video and leadership-focused ad copywriting',
  'Landing pages and executive application flows',
  'Targeted campaign design built to reach experienced operators',
  'Compensation and role benchmarking by region',
  'Pre-launch system stress test',
  'Covers implementation of standard and leadership campaign',
]

// Added to Implementation when "Find a leader" is active.
export const leaderFunnelInclusion =
  'A separate funnel designed specifically for sales leader candidates'

export const leaderMonthlyInclusions = [
  'Active ad management and real-time optimization',
  'Targeted outreach to experienced operators and team leaders',
  'Interview execution handled for you',
  'Vetted candidates passed to you for final approval only',
  'Monthly recruiting review and ongoing consulting',
]

// Leaders follow the same milestone bonuses as a standard campaign hire.
export const leaderPerformanceInclusions = [
  'Placement bonus earned at day 15 active in the field',
  'Retention bonuses earned at day 45 and day 90 active in the field',
  'Nothing earned on resumes, interviews, or hires that never produce',
  'Our upside is tied to the operator staying and producing',
]

// Monthly model: a single placement bonus, no retention bonuses.
export const placementOnlyInclusions = [
  'One-time placement bonus earned at day 15 active in the field',
  'Nothing earned on resumes, interviews, or hires that never produce',
  'No implementation fee, just monthly service and placements',
  'Our upside is tied to the reps who stay and sell',
]

// Monthly model: what the setup covers, with no one-time fee.
export const setupIncludedNote =
  'No implementation fee. Setup is included in your monthly partnership.'

export const performanceInclusions = [
  'Placement bonus earned at day 15 active in the field',
  'Retention bonus earned at day 45 active in the field',
  'Nothing earned on resumes, interviews, or hires that never produce',
  'Our upside is tied to the reps who stay and sell',
]
